"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, findAllIn, trigger} from "@elements/dom-utils";
import Dropdown from 'bootstrap/js/dist/dropdown';

let openDropdownId;

export function init () {
    onFind('.js-filter-dropdown', function (element) {
        let toggle = findIn('.js-filter-dropdown__btn', element),
            id = toggle.getAttribute('id');

        on('shown.bs.dropdown', function () {
            openDropdownId = id;
        }, element);

        on('hidden.bs.dropdown', function () {
            if (openDropdownId === id) {
                openDropdownId = null;
            }
        }, element);

        let resetButton = findIn('.js-filter-dropdown__reset', element);
        if (resetButton) {
            on('click', function () {
                let checkedInputs = findAllIn('input[type="checkbox"]:checked', element);
                checkedInputs.forEach(input => input.checked = false);

                // a single change event is enough for the ajax form to submit the new state once
                if (checkedInputs.length) {
                    trigger('change', checkedInputs[0]);
                }
            }, resetButton);
        }

        if (openDropdownId === id) {
            Dropdown.getOrCreateInstance(toggle).show();
        }
    });
}
